import styled from 'styled-components';
export const FileData = styled.div`
  margin: 0.25em;
  flex-grow: 1;
`;
